var map = {
	"./Country-Insights-Students.jpg": "6eef",
	"./country-insights-macro.jpg": "13d7",
	"./country-insights-map.jpg": "eb165",
	"./country-insights-nigeria.jpg": "7eae",
	"./country-insights-public-holidays.jpg": "2c04",
	"./country-insights-table.jpg": "21d3",
	"./country-insights-verifications.jpg": "7b97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa8d";